import React, { Component } from "react";
import { Button, Heading, Checkbox, Header } from "rsuite";
import axios from "../axiosIn";

export class AceptaResponsiva extends Component {
  constructor(props) {
    super(props);

    this.state = {
      esTutor: 0,
      carrera: this.getCookie("carrera"),
    };
    this.getCierre();
  }

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  getCierre = async () => {
    var url = `DatosCarrera/getCierre`;
    await axios
      .get(url)
      .then((res) => {
        if(res.data === 1){
          window.location.href = "#/CierreEvento";
        }
      })
      .catch((err) => console.error(err));
  };

  clickComenzar = () => {
    window.location = `/#/AceptaResponsiva/Registro/aceptado=1/esTutor=${this.state.esTutor}`;
  };

  clickEsTutor = () => {
    var ck = document.getElementById("ckEsTutor");
    if (ck.ariaChecked === "true") {
      this.setState({ esTutor: 0 });
    } else {
      this.setState({ esTutor: 1 });
    }
  };

  componentDidMount() {
    console.log(this.getCookie("cierre"));
  }

  render() {
    const { esTutor, carrera } = this.state;
    return (
      <>
        <div
          style={{
            backgroundImage: "url(Images/fondoRespon.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100%",
            height: "auto",
            position: "fixed",
            top: 0,
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
        >
          <div className="container">
            <div className="container">
              <div className="row" style={{ height: "80px" }}>
                &nbsp;
              </div>
              <div className="row"></div>
              <div className="row">
                <div className="col">
                  <Header
                    style={{
                      backgroundColor: "white",
                      height: "auto",
                      padding: "20px",
                      borderRadius: "5px",
                      opacity: 0.95,
                    }}
                  >
                    <b>EXONERACIÓN DEL EVENTO</b>
                    <br></br>
                    <b>CARRERA "{carrera}"</b>
                    <br></br>
                    Entiendo que en todo evento o actividad deportiva existen
                    riesgos, por ello tengo la firme intención de ser
                    responsable de mí mismo, de mi cuidado personal, de mis
                    actitudes y de mis conductas dentro del evento. Absuelvo al
                    Comité Organizador de este evento o actividad, de toda
                    responsabilidad derivadas de enfermedad, alergias, lesiones
                    y daños que pueda sufrir como resultado de mi participación,
                    tanto en traslados como en los espacios e instalaciones
                    utilizados en el evento. También doy fe de que estoy en
                    condiciones físicas adecuadas, tengo suficiente preparación
                    para participar y mi condición de salud ha sido verificada
                    recientemente por un médico. No obstante, doy mi
                    consentimiento para que mis familiares, tomen las medidas y
                    hagan los arreglos que consideren necesarios y convenientes
                    para mi salud y mi bienestar, si se presentara
                    alguna contingencia.
                    <br></br>
                    <b>En caso de ser menor de edad:</b>
                    <Checkbox onClick={this.clickEsTutor} id="ckEsTutor">
                      Soy el Padre o Tutor
                    </Checkbox>
                  </Header>
                  <br></br>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Button
                    appearance="primary"
                    style={{ width: "100%" }}
                    onClick={this.clickComenzar}
                  >
                    Aceptar y comenzar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
